import { Button, Modal, Text } from '@fozito/common-ui';
import { IProductItem } from 'modules/shop/types/product';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import empty_product_img from './empty-product.svg';
const Price = styled.div`
display: flex;
padding: 4px 8px;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 4px;
background: #232F3E;
`;
const Inputs = styled.div`
display: flex;
padding: 8px 0px;
justify-content: center;
align-items: flex-start;
gap: 16px;
align-self: stretch;
border-top: 1px solid #86909C;
border-bottom: 1px solid #86909C;
`;
const Input = styled.div`
display: flex;
width: 240px;
flex-direction: column;
align-items: center;
gap: 6px;
align-self: stretch;
border-right: 1px solid #CCD4DC;
`;
const Footer = styled.div`
display: flex;
padding: 16px 16px 24px 16px;
align-items: flex-end;
gap: 16px;
align-self: stretch;
margin-top: 32px;
background: #FFF;
box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.15);
`;
type Props = {
  visible?: boolean;
  data?: IProductItem | null;
  onClose?: () => void;
};
const ModalProductInfo = ({ data, onClose, visible }: Props) => {
  return (
    <Modal title='' isOpen={visible} onClose={onClose} styles={{
      header: { display: 'none' }, body: {
        display: 'flex',
        padding: '24px 0px 0px 0px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        alignSelf: 'stretch',
      }
    }}>
      <img src={data?.urlImage || empty_product_img} style={{ height: 290, width: 'auto' }} />
      <Text title_h2_32_semibold color_secondary_3 text_center>{data?.productName || '--'}</Text>
      <Price>
        <Text title_h5_24_semibold color_text_1 text_center>{formatCurrency(data?.sellPrice)}</Text>
      </Price>
      <Text title_h8_18_medium color_text_4 text_center>Code: {data?.productCode || '--'}</Text>
      <Inputs>
        <Input>
          <Text title_h4_24_medium text_center>Sold</Text>
          <Text title_h2_32_semibold text_center>{data?.quantitySold || 0}</Text>
        </Input>
        <Input style={{ border: 'none' }}>
          <Text title_h4_24_medium text_center>Inventory</Text>
          <Text title_h2_32_semibold text_center>{data?.inventory || 0}</Text>
        </Input>
      </Inputs>
      <Footer>
        <Button style={{ flex: 1 }} block type_cancel onClick={onClose}>Close</Button>
      </Footer>
    </Modal>
  );
};

export default ModalProductInfo;
